import React from "react";
import styled from 'styled-components';
import {  variables, devices  } from "@d19n/ui-core";
import { Container } from "./Container";
import logo from './../../assets/image/svg/logo.svg';

import facebook from './../../assets/image/svg/social/facebook.svg';
import twitter from './../../assets/image/svg/social/twitter.svg';
import instagram from './../../assets/image/svg/social/instagram.svg';
import linkedin from './../../assets/image/svg/social/linkedin.svg';

import { BrowserView, MobileView } from 'react-device-detect';

import { Link } from "gatsby";

const Section = styled.div`
    position: relative;
    margin: 0px auto;
    padding: 5px 15px;
    width: calc(100% - 30px);
    max-width: ${variables.secondary};
`;

const FooterWrapper = styled.div`
    background-color: ${variables.primary};
    p, a {
        color: ${variables.textSecondary};
    }
`;

const FooterContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 15px;

    @media ${devices.tabletOnly} {
        flex-direction: column;
        text-align: center;
    }
`;

const FooterBlock = styled.div`
    flex-basis: 100%;
    p {
        margin-bottom: 1rem;
    }
    * {
        display: block;
    }

    @media ${devices.tabletOnly} {
        margin-bottom: 2rem;
    }
`;

const Copyright = styled.div`
    border-top: 1px solid ${variables.lightGrey};
    p {
        font-size: ${variables.textSizeSmall}
    }
    margin: auto;
    text-align: center;
    padding: 15px 0;
    width: calc(100% - 30px);
    max-width: ${variables.maxWidth};
`;

const Social = styled.div`
    margin-top: 70px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 20px;

    @media ${devices.tabletOnly} {
        justify-content: center;
    }
`;

const Logo = styled.div`
    @media ${devices.tabletOnly} {
        img {
            margin: auto;
        }
    }
    
`;

const Footer = () => {
    return (
        <FooterWrapper>
            <Container>
                <FooterContainer>
                    <FooterBlock>
                        <Logo>
                            <Link to="/" >
                                <img src={logo} />
                            </Link>
                        </Logo>
                        <Social>
                            <a href="https://www.facebook.com/YouFibre/" target="_blank"><img src={facebook} /></a>
                            <a href="https://twitter.com/youfibre" target="_blank"><img src={twitter} /></a>
                            <a href="https://www.instagram.com/youfibre/?hl=en" target="_blank"><img src={instagram} /></a>
                            <a href="https://www.linkedin.com/company/youfibre/" target="_blank"><img src={linkedin} /></a>
                        </Social>
                    </FooterBlock>
                    <FooterBlock>
                        <p><strong>Contact</strong></p>
                        <BrowserView>
                            <p>Business 0330 818 1667</p>
                            <p>Support 0330 822 2222</p>
                        </BrowserView>
                        <MobileView>
                            <a href="tel:03308181667">Business 0330 818 1667</a>
                            <a href="tel:03308222222">Support 0330 822 2222</a>
                        </MobileView>
                    </FooterBlock>
                    <FooterBlock>
                        <p><strong>Useful links</strong></p>
                        <Link to="https://www.youfibre.com/why-youfibre/" target="_blank">Home Broadband</Link>
                        <Link to="https://www.youfibre.com/switch/" target="_blank">Switch</Link>
                        <Link to="https://www.youfibre.com/reviews/" target="_blank">Reviews</Link>
                        <Link to="https://support.youfibre.com/" target="_blank">Support</Link>
                        <Link to="https://www.youfibre.com/legal/complaints-code-of-practice/">Complaints Code</Link>
                        <Link to="https://www.youfibre.com/legal/business-terms-and-conditions/">Business T&C</Link>
                    </FooterBlock>
                    <FooterBlock>
                        <p><strong>Company</strong></p>
                        <Link to="https://www.youfibre.com/news/" target="_blank">News</Link>
                        <a href="https://careers.substantial.group/youfibre" target="_blank" rel="noopener noreferrer">Careers</a>
                        <Link to="https://www.youfibre.com/legal/" target="_blank">Legal</Link>
                    </FooterBlock>
                </FooterContainer>
            </Container>
            <Copyright>
                <p>
                    © {new Date().getFullYear()} YouFibre Limited is a company registered in England (No.12359292).
                    Our registered address is 167-169 Great Portland Street, 5th Floor, London, W1W 5PF, United Kingdom.
                    YouFibre Limited. All Rights Reserved.
                </p>
            </Copyright>
        </FooterWrapper>
    )
};

export default Footer;
